<mat-card id="pharmacy-search">
    <app-matspinner *ngIf="isLoading"></app-matspinner>
    <mat-card-header>
      <mat-card-title class="title">Vendor Search</mat-card-title>
    </mat-card-header>
    <mat-divider  class="divider" style="margin-bottom: 0%;"></mat-divider>
    <br>
<!-- <div style="position: relative;top: 47px;left: -20px;"><button mat-raised-button color="primary" style="float: right;" (click)="ExportTOExcel()">Export</button></div> -->
    <mat-card-content>
  <div class="container">
  <form>
    <div class="row form-row">
      <div class="col-md-6">
        <mat-form-field class="ffs" appearance="outline">
          <input
            matInput
            id="vendor-search-input"
            type="text"
            (keyup)="applyFilter($event)"
            placeholder="Search Vendors"
            #input
            autocomplete="off"
          >
        </mat-form-field>
      </div>
    </div>
  </form>
</div>

<div class="mat-elevation-z8 table-container">
    <table mat-table [dataSource]="dataSource" matSort>

        <ng-container matColumnDef="VendorId" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Vendor ID </th>
            <td mat-cell *matCellDef="let row" class="table-row-font"> {{row.VendorId}}
            </td>
        </ng-container>

        <ng-container matColumnDef="VendorName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header-font"> Vendor Name </th>
            <td mat-cell *matCellDef="let row" class="table-row-font">
                {{row.VendorName}} </td>
        </ng-container>

        <ng-container matColumnDef="edit">
            <th mat-header-cell *matHeaderCellDef class="table-header-font">Edit</th>
            <td mat-cell *matCellDef="let element" class="table-row-font" >
                <button mat-icon-button color="primary" (click)="redirectToEdit(element.VendorId)">
                    <mat-icon class="mat-18">edit</mat-icon>
                </button>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: !isLoading?true:false"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
            <!-- <td class="mat-cell" colspan="4">No data matching the filter "{{input.value}}"</td> -->
            <td class="mat-cell" colspan="4">No Vendors Found</td>
        </tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 30, 100]" aria-label="Select page of users" [ngClass]="{'mat-paginator-sticky': !isLoading }">
    </mat-paginator>
</div>
</mat-card-content>
</mat-card>